export enum ModuleType {
  ASSESSMENT = 'ASSESSMENT',
  CORE = 'CORE',
  CONTINUOUS = 'CONTINUOUS',
  EXTERNAL_TRAINING = 'EXTERNAL_TRAINING',
  ETHENA_LOCKED_CORE = 'ETHENA_LOCKED_CORE',
  ETHENA_LOCKED_CONTINUOUS = 'ETHENA_LOCKED_CONTINUOUS',
  IMPORTED_CUSTOM_MODULE = 'IMPORTED_CUSTOM_MODULE',
  RESOURCE = 'RESOURCE',
}

export enum ModuleVersionReleaseReason {
  NEW_RELEASE = 'NEW_RELEASE',
  MINOR = 'MINOR',
  ETHENA_LOCKED_MIGRATION = 'ETHENA_LOCKED_MIGRATION',
}

export interface IModule {
  companyId?: number;
  courseId: number;
  description: string;
  id: number;
  isDeleted: boolean;
  lengthInMinutes: number;
  name: string;
  previewUrl: string;
  publishDate?: string;
  type: ModuleType;
}
